import { jsPDF } from 'jspdf';
import logo from '../../../icons/Cet_emblem.jpg';
import converter from 'number-to-words'

const generateBillPDF = (billData) => {
  try {
    // Initialize PDF with default font
    const doc = new jsPDF();

    // Function to convert number to words

    // Function to generate single bill copy
    const generateBillCopy = (startY, type) => {
      try {
        // Header
        doc.addFont('times', 'Times', 'normal');
        doc.setFont('Times');

        // Add logo
        doc.addImage(logo, 'PNG', 10, startY + 5, 30, 30);

        doc.setFontSize(16);
        doc.text("HOSTEL OFFICE - COLLEGE OF ENGINEERING", 105, startY + 15, { align: "center" });
        doc.text("THIRUVANANTHAPURAM - 16", 105, startY + 23, { align: "center" });

        doc.setFontSize(13);
        doc.text("Ph: 0471- 2515689, e-mail Id warden@cet.ac.in", 105, startY + 31, { align: "center" });


        // Bill details

        doc.line(20, startY + 35, 190, startY + 35);

        doc.setFontSize(13);
        doc.setFont("Times", "bold");
        doc.text("MESS-BILL RECEIPT", 20, startY + 56,);

        doc.setFontSize(11);
        doc.setFont("Times", "normal");

        const billNumber = `No. ${billData?.receipt_no || ''}`;
        const dateStr = new Date().toLocaleDateString();
        doc.text(billNumber, 20, startY + 45);
        doc.text(`Date: ${dateStr}`, 150, startY + 45);

        // Student details

        doc.setFont("Times", "bold");
        doc.text("Student Details:", 20, startY + 65);
        doc.setFont("Times", "normal");
        const hostelAdmissionNo = `Hostel Admission No: ${billData?.hostel_admission_no || ''}`;
        const admissionNo = `Admission No: ${billData?.admission_no || ''}`;
        const studentName = `Name: ${billData?.name || ''}`;
        doc.text(hostelAdmissionNo, 20, startY + 74);
        doc.text(admissionNo, 150, startY + 74);
        doc.text(studentName, 20, startY + 81);
        doc.text(`Month: ${new Date(billData.year, billData.month - 1).toLocaleString('default', { month: 'long' })} ${billData.year}`, 150, startY + 81);



        // Table headers
        doc.text("Description", 25, startY + 90);
        doc.text("Amount ", 150, startY + 90);

        doc.line(20, startY + 92, 190, startY + 92);

        // Bill items`
        let currentY = startY + 98;

        // Safely convert numbers to strings with fallback to '0'
        // const totalBill = (billData?.amount || 0).toString();
        const rentPaid = (billData?.rent_paid || 0).toString();
        const finePaid = (billData?.fine_paid || 0).toString();
        const messBill = (billData?.amount)

        doc.text("Mess Bill", 25, currentY);
        doc.text(`Rs.${messBill}/-`, 150, currentY);
        currentY += 7;
        doc.text("Rent", 25, currentY);
        doc.text(`Rs.${rentPaid}/-`, 150, currentY);

        currentY += 7;
        doc.text("Fine", 25, currentY);
        doc.text(`Rs.${finePaid}/-`, 150, currentY);

        // Calculate total
        const total = (Number(messBill) + Number(rentPaid) + Number(finePaid));

        // Total
        doc.line(20, currentY + 4, 190, currentY + 4);
        doc.text("Total Amount", 25, currentY + 8);
        doc.text(total.toString(), 150, currentY + 8);

        // Amount in words
        doc.text(`(${converter.toWords(total)})`, 140, currentY + 12);

        // Footer
        doc.text("Authorized Signatory", 150, currentY + 30);

        // Copy indicator
        doc.setFontSize(10);
        doc.text(type, 20, currentY + 40);
      } catch (error) {
        console.error('Error in generateBillCopy:', error);
        throw error;
      }
    };

    // Generate first copy
    generateBillCopy(0, "OFFICE COPY");

    // Add dividing line

    // Set line dash pattern for dotted line
    doc.setLineDash([2, 2]);
    const width = 190

    // Draw the dotted line
    doc.line(10, 148, 10 + width, 148);

    // Add scissors symbol at start (unicode scissors ✂)
    doc.setFont("Helvetica");
    doc.setFontSize(12);

    // Add "Cut Here" text
    doc.setFontSize(8);
    doc.text("Cut Here", 10 + width / 2 - 15, 148 - 5);
    doc.setLineDash([])
    // Restore the graphics state
    // doc.line(10, 148, 200, 148);
    // doc.setFontSize(8);
    // doc.text("✂ Cut Here", 105, 146, { align: "center" });

    // Generate second copy
    generateBillCopy(150, "DUPLICATE");

    return doc;
  } catch (error) {
    console.error('Error in generateBillPDF:', error);
    throw error;
  }
};

export const generateAndDownloadBill = async (billData) => {
  try {
    if (!billData) {
      throw new Error('Bill data is required');
    }

    const doc = generateBillPDF(billData);

    // Generate filename
    const filename = `receipt_${billData.hostel_admission_no || 'unknown'}_${billData.month || ''}_${billData.year || ''}.pdf`;

    doc.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};